import { createSelector } from 'reselect'

export const getProfileState = (state) => state.mars.profile

export const getProfileBattlesData = createSelector(
  [getProfileState],
  (profile) => profile.profileBattles
)
